import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../axios";
import { notification } from "antd";

export default function TutorInterest() {
  const { dealId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [countdown, setCountdown] = useState(5);
  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, desc) => {
    api[type]({
      message: message,
      description: desc,
      placement: "topRight",
    });
  };

  useEffect(() => {
    if (dealId) {
      axios
        .post("/v1/tutor/whatsapp-applied-jobs", {
          dealings_id: dealId,
        })
        .then((response) => {
          setLoading(false);
          if (response.data.is_success) {
            setIsSuccess(true);
            setStatusMessage("Your interest has been submitted successfully.");
            openNotificationWithIcon(
              "success",
              "Success",
              "Application submitted successfully!"
            );
          } else {
            setIsSuccess(false);
            setStatusMessage(response.data.error || "Failed to submit application.");
            openNotificationWithIcon(
              "error",
              "Error",
              response.data.error || "Failed to submit application"
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          setIsSuccess(false);
          setStatusMessage("Failed to submit application. Please try again.");
          openNotificationWithIcon(
            "error",
            "Error",
            "Failed to submit application. Please try again."
          );
        });
    }
  }, [dealId, navigate]);

  // Auto-redirect with countdown on success
  useEffect(() => {
    if (!loading && isSuccess) {
      setCountdown(5);

      const intervalId = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(intervalId);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      const timeoutId = setTimeout(() => {
        navigate("/dashboard");
      }, 5000);

      return () => {
        clearInterval(intervalId);
        clearTimeout(timeoutId);
      };
    }
  }, [loading, isSuccess, navigate]);

  return (
    <main className="main">
      {contextHolder}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
          flexDirection: "column",
        }}
      >
        {loading ? (
          <>
            <img src="/book-loader.gif" alt="Loading..." />
            <p style={{ marginTop: "20px" }}>Processing your application...</p>
          </>
        ) : (
          <>
            <h2 style={{ marginBottom: "10px", textAlign: "center" }}>
              {isSuccess ? "Thank you!" : "Something went wrong"}
            </h2>
            <p style={{ marginBottom: "10px", textAlign: "center" }}>{statusMessage}</p>
            {isSuccess && (
              <p style={{ marginBottom: "10px", textAlign: "center" }}>
                Redirecting to dashboard in {countdown} second{countdown !== 1 ? "s" : ""}...
              </p>
            )}
            <button
              type="button"
              onClick={() => navigate("/dashboard")}
              style={{
                marginTop: "10px",
                padding: "8px 16px",
                backgroundColor: "#274178",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Go to Dashboard
            </button>
          </>
        )}
      </div>
    </main>
  );
}

